import { AltOffering } from './entities';

export const sortOfferings = (offerings?: AltOffering[]) => {
  return offerings?.sort(sortByDate).sort(sortByFeatured).sort(sortByFunded) ?? [];
};

export const sortByDate = (a: AltOffering, b: AltOffering) => {
  if (a.createdAt > b.createdAt) return -1;
  else if (a.createdAt < b.createdAt) return 1;
  else return 0;
};

export const sortByNewest = (a: AltOffering, b: AltOffering) => {
  return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
};

export const sortByFeatured = (a: AltOffering, b: AltOffering) => {
  if (a.featured > b.featured) return -1;
  else if (a.featured < b.featured) return 1;
  else return 0;
};

export const sortByFunded = (a: AltOffering, b: AltOffering) => {
  if (a.funded > b.funded) return 1;
  else if (a.funded < b.funded) return -1;
  else return 0;
};

export const sortByPriority = (a: AltOffering, b: AltOffering) => {
  if (Number(b.priority) < Number(a.priority) || Number(b.priority) === 0) {
    return -1;
  } else if (Number(b.priority) > Number(a.priority)) {
    return 1;
  }
  return 0;
};

export const sortByRecommended = (a: AltOffering, b: AltOffering) => {
  if (a.updatedAt === b.updatedAt) {
    return sortByNewest(a, b);
  } else {
    return sortByPriority(a, b);
  }
};

export const sortByHighestYield = (a: AltOffering, b: AltOffering) => {
  return (b.projectedReturnLow ?? 0) - (a.projectedReturnLow ?? 0);
};

export const sortByLowestYield = (a: AltOffering, b: AltOffering) => {
  return (a.projectedReturnLow ?? 0) - (b.projectedReturnLow ?? 0);
};

export const sortByHighestMinimumInvestment = (a: AltOffering, b: AltOffering) => {
  return (b.minInvestment ?? 0) - (a.minInvestment ?? 0);
};

export const sortByLowestMinimumInvestment = (a: AltOffering, b: AltOffering) => {
  return (a.minInvestment ?? 0) - (b.minInvestment ?? 0);
};
